import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from "../../../../axiosinterceptor";

const initialState = {
  coderCard:{
    documentationCard: true,
    codingScreenCard: true,
    codeBookCard: true
  },
  auditStatusState : {
    auditStatusStatusLoading: false,
    auditStatusStateData: {},
    auditStatusStateError: null,
  },
  episodesData: [],
  isEpisodesLoading: false,
  episodeError: null,
  drgOptionsData: [],
  loadingDrgOptionsData: false,
  errorsDrgOptionsData: null,
  drgInformation: [],
  loadingDrgInformation: true,
  errorsDrgInformation: null,
};
export const fetchEpisodes = createAsyncThunk(
  "coder/fetchEpisodes",
  async (episodeListFilterObj, { rejectWithValue }) => {
      try {
        const response = await axiosInstance.post(
            "/Filter_navigation_acs",
            episodeListFilterObj
        );
        const data = response?.data;
          return data.episode;
      } catch (error) {
          return rejectWithValue(error.message);
      }
  }
);
export const fetchDrgOptions = createAsyncThunk(
  "coder/fetchDrgOptions",
  async (payload,{ rejectWithValue }) => {
      try {
          const response = await axiosInstance.post(
              "/drg_options",
              payload
          );
          console.log(response,'drgopt');
          
          return response.data;
      } catch (error) {
          return rejectWithValue(error.message);
      }
  }
);
export const fetchAllCodesbyStepFunction = createAsyncThunk(
  "coder/fetchAllCodesbyStepFunction",
  async (payload,{ rejectWithValue }) => {
      const new_hcp_line_id = localStorage.getItem("last_epi_identifier");
      const case_mix_speciality=localStorage.getItem("case_mix_speciality");
      try {
          const response = await axiosInstance.post(
              "https://cqpqzxetra.execute-api.ap-southeast-2.amazonaws.com/agent_step_function/agentic_step_functions",
              {
                episode_id:new_hcp_line_id,
                case_mix:case_mix_speciality
              }
          );
          console.log(response,'drgopt');
          
          return response.data;
      } catch (error) {
          return rejectWithValue(error.message);
      }
  }
);
export const fetchAllCodesProgress = createAsyncThunk(
  "coder/fetchPrincipalDiagnosisCodes",
  async (payload,{ rejectWithValue }) => {
      try {
          const response = await axiosInstance.post(
              "https://1qwtwtzbci.execute-api.ap-southeast-2.amazonaws.com/agentic_step_function_status ",
              {
                executionArn:payload
              }
          );
          return response.data;
      } catch (error) {
          return rejectWithValue(error.message);
      }
  }
);
export const fetchDrgInformation =createAsyncThunk(
    "coder/fetchDrgInformation",
    async (payload,{ rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(
                "/drg_grouping_additional_information",
                payload
            );
            // console.log(response,'drgopt');
            
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
  );

  export const getAuditResponse = createAsyncThunk(
    '/getAuditResponse',
    async (payload, { fulfillWithValue, rejectWithValue }) => {
      try {
        const response = await axiosInstance.get(`/get_audit_log?hcp_line_id=${payload.hcp_line_id}&episode_identifier=${payload.episode_identifier}`);
        const lines = response?.data?.body?.replace(/\\n/g, '\n')?.split('\n');
          // console.log(response?.data?.body, 'lines')
        const parsedData = {};
        lines.forEach(line => {
          const [key, value] = line?.split(':')?.map(s => s?.trim());
          parsedData[key] = value;
        });
        
        console.log(parsedData, 'parsedData');
        return fulfillWithValue(parsedData);
      } catch (error) {
        console.error('Error fetching Audit Details:', error);
        return rejectWithValue(error.response?.data?.message || error.message || "No data found");
      }
    }
  );

const coderSlicer = createSlice({
  name: "coderSlicer",
  initialState,
  reducers: {
    setDocumentationCard: (state, action) => {
        state.coderCard.documentationCard = action.payload;
    },
    setCodingScreenCard: (state, action) => {
        state.coderCard.codingScreenCard = action.payload;
    },
    setCodeBookCard: (state, action) => {
        state.coderCard.codeBookCard = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
        .addCase(fetchEpisodes.pending, (state) => {
            state.isEpisodesLoading = true;
            state.episodeError = null;
        })
        .addCase(fetchEpisodes.fulfilled, (state, action) => {
            state.isEpisodesLoading = false;
            state.episodesData = action.payload;
        })
        .addCase(fetchEpisodes.rejected, (state, action) => {
            state.isEpisodesLoading = false;
            state.episodeError = action.payload;
        })
        .addCase(fetchDrgOptions.pending, (state) => {
          state.loadingDrgOptionsData = true;
          state.errorsDrgOptionsData = null;
      })
      .addCase(fetchDrgOptions.fulfilled, (state, action) => {
          state.loadingDrgOptionsData = false;
          state.drgOptionsData = action.payload;
      })
      .addCase(fetchDrgOptions.rejected, (state, action) => {
          state.loadingDrgOptionsData = false;
          state.errorsDrgOptionsData = action.payload;
      })
      .addCase(fetchDrgInformation.pending, (state) => {
        state.loadingDrgInformation = true;
        state.errorsDrgInformation = null;
    })
    .addCase(fetchDrgInformation.fulfilled, (state, action) => {
        state.loadingDrgInformation = false;
        state.drgInformation = action.payload;
    })
    .addCase(fetchDrgInformation.rejected, (state, action) => {
        state.loadingDrgInformation = false;
        state.errorsDrgInformation = action.payload;
    })
    .addCase(getAuditResponse.pending, (state) => {
        state.auditStatusState.auditStatusStatusLoading = true;
        state.auditStatusState.auditStatusStateError= null;
    })
    .addCase(getAuditResponse.fulfilled, (state, action) => {
        state.auditStatusState.auditStatusStatusLoading = false;
        state.auditStatusState.auditStatusStateData = action.payload;
    })
    .addCase(getAuditResponse.rejected, (state, action) => {
        state.auditStatusState.auditStatusStatusLoading = false;
        state.auditStatusState.auditStatusStateError = action.payload;
    })
},
});
export const { setDocumentationCard, setCodingScreenCard, setCodeBookCard } = coderSlicer.actions;

export default coderSlicer.reducer